$(document).ready(function(){
  $('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/down-arrow.png?v=1690557816"]').attr("alt", "Down arrow icon");
$('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/Background.png?v=1681145096"]').attr("alt", "Mail icon");

$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/top-10-best-pitching-machines_5f6e693e-da5c-465d-b852-7df1ef0fd2e2.jpg?v=1685702255&width=1320"]').attr("alt", "Top 10 best pitching machines");

$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/how-to-choose-the-perfect-bat-size_bf338b85-a287-4aad-bae3-1295837de199.jpg?v=1685702322&width=1320"]').attr("alt", "How to choose the perfect bat size");

$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/how-to-pick-the-right-batting-cage_203f1bcd-f07f-436e-a4b0-0f279ce1b19a.jpg?v=1685702254&width=1320"]').attr("alt", "How to pick the right batting cage");
$("img[src*='Manual_100x100.png']").attr('alt',"pdf icon");
  $("div.slideshow__text-wrapper div.button-wrapper a").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

  
 
   $("div.product-item__label-list.label-list span.label.label--highlight").each(function() {
        var link = $(this);
        var linkText = link.text();
        // Extract the money value from the text, including the dollar sign, and decimals, also, delete it from the text
        var moneyValue = linkText.match(/\$[0-9]+(\.[0-9]+)?/g);
        linkText = linkText.replace(moneyValue, '');
        // Create a new span element with the money value and the class 'bc igSavingsPrice'
        var moneySpan = $('<span>').text(moneyValue.join(', ')).addClass('bc igSavingsPrice');
    var spanElement = $('<span>').text(linkText).addClass('bc');
    spanElement.append(moneySpan);
        link.html(spanElement);
    });

  $("#shopify-section-template--15010449358919__409235a1-c996-47dd-84a9-a9429f034cc7 > section > div > div > div > div > div > a > button").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

  
$('img[src="https://i.ytimg.com/vi/JZfG3a1XXUQ/hqdefault.jpg"]').attr("alt", "Heater Sports Deuce review thumbnail");

$('img[src="https://i.ytimg.com/vi/77a7CbEMGJI/hqdefault.jpg"]').attr("alt", "Junior pitching machine review thumbnail");
$('select[name="filter.v.availability"]').attr("aria-label", "Filter by availability");
$('img[src*="https://cdn.shopify.com/s/files/1/2195/7127/files/need-help-ebook-link_v2.jpg?v=1679077371"]')
    .attr("alt", "Need help ebook link");
$('#shopify-section-template--15010448801863__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > h3:nth-child(63)').append("<span style='display:none'>.</span>")
   $('div.youtube-player img').each(function() {
        if (!$(this).attr('alt') || $(this).attr('alt').trim() === '') {
            $(this).attr('alt', 'YouTube Thumbnail');
        }
    });

  setTimeout(function() {
   
  $("label[for^='review_email']").removeAttr("for");
 $("label[for^='review_location']").removeAttr("for");
 $("label[for^='reviewRating']").removeAttr("for");
 $("label[for^='review_title']").removeAttr("for");
    $("label[for^='stamped-file-uploader']").removeAttr("for");
    
     $("label[for^='question_author'], label[for^='question_email'], label[for^='question_body'], label[for^='review_author'],label[for^='review_body']").removeAttr("for");
      
}, 1000);


let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if ( $("div.stamped-review-avatar-content").length) {

$("div.stamped-review-avatar-content").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}

  
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$("label[for^='review_email']").removeAttr("for");
 $("label[for^='review_location']").removeAttr("for");
 $("label[for^='reviewRating']").removeAttr("for");
 $("label[for^='review_title']").removeAttr("for");
    $("label[for^='stamped-file-uploader']").removeAttr("for");
    
    
     $("label[for^='question_author'], label[for^='question_email'], label[for^='question_body'], label[for^='review_author'],label[for^='review_body']").removeAttr("for");
    $("input[name='name']").attr("aria-label", "Enter your Name");
     $("input[name='email']").attr("aria-label", "Enter Email");
    $("input[name='location']").attr("aria-label", "Enter Location");
  $("textarea[name='reviewBody']").attr("aria-label", "Enter review body");
  $("input[name='author']").attr("aria-label", "Enter author name");
  $("textarea[name='reviewMessage']").attr("aria-label", "Enter Review Message");
  
    $("input[name='reviewRating']").attr("aria-label",  "Enter Review Rating");
    $("input[name='reviewTitle']").attr("aria-label", "Enter Review Title");
$("a[href='https://stamped.io/go/d3xXaWRnZXRDYXJvdXNlbHw4MTA0NnxyfDE0MTg2OTUzMQ2']").attr("aria-label", "Stamped review link 1");
$("a[href='https://stamped.io/go/d3xXaWRnZXRDYXJvdXNlbHw4MTA0NnxyfDEzNjkzNDQ1Nw2']").attr("aria-label", "Stamped review link 2");
$("a[href='https://stamped.io/go/d3xXaWRnZXRDYXJvdXNlbHw4MTA0NnxyfDEzNjYyOTk4Ng2']").attr("aria-label", "Stamped review link 3");

   
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');
         
  
   
$("div.stamped-review-avatar-content").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}



  $('img[src*="shipping_95f7e0e3-bd7b-4e55-bc23-ae696f9e3401.png"]').attr("alt", "shipping truck icon");
    $('img[src*="phone_15a1e83e-072c-427d-bf5b-98a401f3763b.png"]').attr("alt", "phone icon");
    $('img[src*="tropy-30.png"]').attr("alt", "trophy icon");
    $('img[src*="//www.anytimebaseballsupply.com/cdn/shop/files/Anytime_Baseball_Supply_Logo-05_320x.png?v=1691778420"]')
        .attr("alt", "Anytime Baseball Supply Logo");
   $("div.product-meta__price-list-container div.product-meta__label-list.label-list span.label.label--highlight").each(function() {
        var link = $(this);
        var linkText = link.text();
// Extract the money value from the text, including the dollar sign, and decimals, also, delete it from the text
        var moneyValue = linkText.match(/\$[0-9]+(\.[0-9]+)?/g);
        linkText = linkText.replace(moneyValue, '');
        // Create a new span element with the money value and the class 'bc igSavingsPrice'
        var moneySpan = $('<span>').text(moneyValue.join(', ')).addClass('bc igSavingsPrice');
    var spanElement = $('<span>').text(linkText).addClass('bc');
spanElement.append(moneySpan);
        link.html(spanElement);
    });

   $('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/full-star-icon.png"]')
    .attr("alt", "Full star icon");
$('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/cash-icon.png?v=1611064736"]')  
    .attr("alt", "Cash icon");

$('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/half-star-icon.png"]')  
    .attr("alt", "Half star icon");
$('a[href="https://www.anytimebaseballsupply.com/collections/fast-pitch-softball-pitching-machines"]')
    .attr("aria-label", "Fast Pitch Softball Pitching Machines Collection");
$("#shopify-section-template--15825936646215__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > div:nth-child(11) > h3").append("<span style='display:none'>.</span>");
  $('a[href="https://www.anytimebaseballsupply.com/products/portolite-4-inch-portable-youth-pitching-mound"]')
    .attr("aria-label", "Portolite 4-Inch Portable Youth Pitching Mound");

$('a[href="https://www.anytimebaseballsupply.com/products/portolite-full-size-6-inch-portable-youth-pitching-mound-6107"]')
    .attr("aria-label", "Portolite Full-Size 6-Inch Portable Youth Pitching Mound");

$('a[href="https://www.anytimebaseballsupply.com/products/8-inch-portable-youth-pitching-mound"]')
    .attr("aria-label", "8-Inch Portable Youth Pitching Mound");

$('a[href="https://www.anytimebaseballsupply.com/products/portolite-10-inch-portable-baseball-pitching-mound"]')
    .attr("aria-label", "Portolite 10-Inch Portable Baseball Pitching Mound");
$('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/pitching_mounds_ebook_cover_3_1.jpg?v=1687784657"]')
    .attr("alt", "Pitching Mounds eBook Cover");
$("#shopify-section-template--15660124569671__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > h3:nth-child(23)").append("<span style='display:none'>.</span>");
  $('a[href="https://www.anytimebaseballsupply.com/products/portolite-pro-spiked-softball-mat"]')
    .attr("aria-label", "Portolite Pro Spiked Softball Mat");
$("#shopify-section-template--15010448801863__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > h3:nth-child(9)").append("<span style='display:none'>.</span>");
$("#shopify-section-template--15010448801863__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > div:nth-child(15) > h3:nth-child(1)").append("<span style='display:none'>.</span>");
  $("#shopify-section-template--15010448801863__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > h2:nth-child(21)").append("<span style='display:none'>.</span>");

  $("#shopify-section-template--15010448801863__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > h2.p2").append("<span style='display:none'>.</span>");
  $('a[href="https://www.anytimebaseballsupply.com/products/on-field-bullpen-mound-for-baseball"]')
    .attr("aria-label", "On-Field Bullpen Mound for Baseball");

  $('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/true-pitch-mounds-authorized-dealer_480x480.jpg?v=1547597671"]')
    .attr("alt", "True Pitch Mounds Authorized Dealer");
$('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/designatedhitter_83b4b262-7772-4594-ab76-dad72dbc796b_480x480.png?v=1679598528"]')
    .attr("alt", "Pitching Dummies");
$('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/weighted-baseballs-for-pitcher-training-set-of-5_a21bfaf0-3bdc-4644-8d39-7811a3e6027c_480x480.jpg?v=1718119131"]')
    .attr("alt", "Weighted Baseballs for Pitcher Training Set of 5");
$('a[href="https://www.anytimebaseballsupply.com/products/spinball-wizard-3-wheel-pitching-machine"]')
    .attr("aria-label", "Spinball Wizard 3-Wheel Pitching Machine");
$('a[href="https://www.anytimebaseballsupply.com/collections/backyard-batting-cages"]')
    .attr("aria-label", "Backyard Batting Cages Collection");
$("#shopify-section-template--15010448801863__411275f8-b363-4b74-8c4f-2b95d1c40221 > section > div > div > div > div > div:nth-child(26) > h4").append("<span style='display:none'>.</span>");
$("#fencingForm > button1").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

$("button.main-search__submit.tap-area").append("<span style='display:none'>.</span>");
$("#shopify-section-template--15010449555527__main div.container a>button.button").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

  $("h2").filter(function() {
    return $(this).contents().length === 1 && $(this).children("br").length === 1;
}).append("<span style='display:none'>.</span>");
  $("h3>br:empty").append("<span style='display:none'>.</span>");
  $('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/ci.png?v=1675704372&width=987"]').attr("alt", "payment methods");
$("#block-template--15010449850439__product-content-description-content > div > div:nth-child(5) > h3:nth-child(14)").append("<span style='display:none'>.</span>");
$('a[href="https://cdn.shopify.com/s/files/1/2195/7127/files/BULLELITEBB_BULLELITESB.PDF?15347310071786489403"]').attr("aria-label", "Bullet Elite Baseball and Softball PDF");
$("#block-template--15010449850439__product-content-description-content > div > h3").append("<span style='display:none'>.</span>");
   $("h2:empty").append("<span style='display:none'>.</span>");
  $("h3.stamped-review-header-title:empty").append("<span style='display:none'>.</span>");
  $('img[src="https://cdn.shopify.com/s/files/1/2195/7127/files/price_b29ef8b3-0bd6-44a9-9488-54cf8377c15c.png?v=1651554601"]').attr("alt", "price tag icon");
$("#block-template--15010449850439__product-content-description-content > div > div:nth-child(16) > h3:nth-child(2)").append("<span style='display:none'>.</span>");
  $('a[href="https://cdn.shopify.com/s/files/1/2195/7127/files/spinball-3-wheel-pitching-machine-manual.pdf?9373344151789036825"]').attr("aria-label", "Spinball 3-Wheel Pitching Machine Manual");
$("#block-template--15010449850439__product-content-description-content > div > div:nth-child(5) > h3").append("<span style='display:none'>.</span>");
  $('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/a.png?v=1679675341&width=600"]').attr("alt", "Easton logo");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/b.png?v=1679675421&width=600"]').attr("alt", "LS logo");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/c.png?v=1679675458&width=600"]').attr("alt", "Rawlings logo");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/d.png?v=1679675494&width=600"]').attr("alt", "Sports Attack logo");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/e.png?v=1679675529&width=600"]').attr("alt", "Pocket Radar logo");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/f.png?v=1679675561&width=600"]').attr("alt", "Jugs Sports logo");
$("#shopify-section-template--15010449293383__image_with_text_block_4HEt67 > section > div > image-with-text-block > div.image-with-text-block__content.content-box.content-box--small.content-box--text-center.content-box--right.text-container > div > div > a").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

$("#shopify-section-template--15010449293383__image_with_text_block_yD7EHN > section > div > image-with-text-block > div.image-with-text-block__content.content-box.content-box--small.content-box--text-center.content-box--left.text-container > div > div > a").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
$("#shopify-section-template--15010449293383__fb171395-7d6d-461a-8c15-0ecdf154d53c > section > div > div > div > div > strong > div > a > button").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

  $('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/Shipping_icon_77a6259a-7509-4bbc-a90a-b277644ffd71_80x.png?v=1678209530"]').attr("alt", "Shipping icon");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/Phone_icon_2a0bc447-4e75-425e-9a57-b65140cb24c3_90x.png?v=1678209557"]').attr("alt", "Phone icon");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/Klarna_icon_88f29b0e-777d-4f48-bfd8-7051a4168309_240x.png?v=1678217731"]').attr("alt", "Klarna icon");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/Secure_icon_b9c1af40-2596-4645-b126-4f34f3bec812_80x.png?v=1678320276"]').attr("alt", "Secure payment icon");
$('img[src="//www.anytimebaseballsupply.com/cdn/shop/files/main-banner_2464ae41-ad3e-4cc1-b045-b0b31996caae.jpg?v=1735602774&width=3000"]').attr("alt", "Homepage main banner");

console.log("ready");
});
